import { Permission } from '@Constants/Permission.g';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiStorageLocation } from '@Model';
import {
    FrameFallback,
    type IFrameEditShellProps,
    useEditFrame,
    useFrameEditBaseNavigation,
} from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { StorageLocationFrameBody } from './StorageLocation/StorageLocationFrameBody';

// @ai-generated 2026-10-21T10:16:14+00:00 by matthias.gessinger@synqony.com using claude-sonnet-5-5

export function FrameEditStorageLocation(props: IFrameEditShellProps<ApiStorageLocation>) {
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    return (
        <StorageLocationEditFrame
            key={primaryKey}
            {...props}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
        />
    );
}

function StorageLocationEditFrame(props: IFrameEditShellProps<ApiStorageLocation> & { primaryKey: string }) {
    const hasPermission = useHasPermission();

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    const events = useMemo(
        () => ({
            ...frameEditBaseNavigationEvents,
            ...props.events,
        }),
        [frameEditBaseNavigationEvents, props.events],
    );

    const frame = useEditFrame<ApiStorageLocation>({
        apiResourcePath: `${STAMMDATEN_API}/storage_locations`,
        primaryKey: props.primaryKey,
        embedded: props.embedded,
        events,
        canEdit: props.canEdit !== false && hasPermission(Permission.StammdatenStorageLocationUpdate),
        canCreate: props.canCreate !== false && hasPermission(Permission.StammdatenStorageLocationCreate),
        canDelete: props.canDelete !== false && hasPermission(Permission.StammdatenStorageLocationDelete),
    });

    if (frame.status !== 'ready') {
        return <FrameFallback frame={frame} />;
    }

    return <StorageLocationFrameBody key={frame.recordId} frame={frame} />;
}
